import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { objIconsMock } from './mockCustomIcons'
@Injectable({ providedIn: 'root' })
export class IconsService {
  iconsName = [
    'layers',
    'search',
    'user',
    'location',
    'zoom-in',
    'zoom-out',
    'marker',
    'error',
    'success',
    'info',
    'warning',
    'close',
    'arrow-up',
    'arrow-down',
    'bin',
    'sample',
    'aval_cons',
    'aval_no_cons',
    'map',
    'earth',
    'three-dots',
    'layers-remove',
    'ruler',
    'ruler-square',
    'magnet',
    'magnet-on',
    'information',
  ];

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    for (const iconName of this.iconsName) {
      this.addIcon(iconName);
    }
  }

  addIcon(iconName: string) {
    this.iconRegistry.addSvgIcon(
      `${iconName}`,
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `../../../assets/icons/${iconName}.svg`
      )
    );
  }

  async registerCustomIcon(path: string, iconName: string) {
    return this.iconRegistry.addSvgIcon(
        iconName,
        this.sanitizer.bypassSecurityTrustResourceUrl(path)
      );
  }

  async preLoadAllIcons(){
    objIconsMock.forEach((item,index) => {
      if (item.folderName !== 'mdi') {
        item.icons.map((icon) => {
          const iconName = `${item.folderName}/${icon}`;
          this.preLoadIcon(iconName);
        });
      }
    });
  }

  async preLoadIcon(iconName: string){
    return this.iconRegistry.getNamedSvgIcon(iconName).subscribe(() => true,(error) => console.error(error));
  }
}
